import axios from 'axios';

let baseApiUrl: string = `${process.env.VUE_APP_CPORTAL_URL}${
    process.env.VUE_APP_CPORTAL_PORT && process.env.VUE_APP_CPORTAL_PORT !== ''
        ? ':' + process.env.VUE_APP_CPORTAL_PORT
        : ''
}${process.env.VUE_APP_CPORTAL_API_PREFIX}`;

/**
 * Default configuration for the axios instance
 **/
let config = {
    baseURL: baseApiUrl,
    timeout: 120000,
};

/**
 * Axios instantiation
 **/
const httpClient = axios.create(config);

export { httpClient };
